// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1s5tq120 {
  height: 38px;
  border-width: 1px;
  border-style: solid;
  border-color: #d1d1d1;
  border-radius: 4px;
  background: #fafafa;
  overflow: hidden;
  padding-left: 4px;
  font-size: 15px;
}
._1s5tq121 {
  border-color: var(--_18w76bw3h);
}
._1s5tq122 {
  border-color: var(--_18w76bw2y);
}
._1s5tq123 {
  border-color: #4a4b4d;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qBAAqB;AACvB","sourcesContent":["._1s5tq120 {\n  height: 38px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #d1d1d1;\n  border-radius: 4px;\n  background: #fafafa;\n  overflow: hidden;\n  padding-left: 4px;\n  font-size: 15px;\n}\n._1s5tq121 {\n  border-color: var(--_18w76bw3h);\n}\n._1s5tq122 {\n  border-color: var(--_18w76bw2y);\n}\n._1s5tq123 {\n  border-color: #4a4b4d;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
